<div class="e-progress-bar">
    <ol class="e-steps" [attr.aria-label]="ariaLabel">
        <li *ngFor="let step of steps"
            [attr.aria-current]="currentStep === step.number ? 'step' : null"
            [ngClass]="{
                'e-step-current' : currentStep === step.number,
                'e-step-complete' : currentStep > step.number || complete === true,
                'e-step-highlight' : currentStep + 1 === step.number && highlightNextStep
            }"
        >
            <div>
                <span class="e-step-title">{{step.title}}</span>
                <span class="e-step-number" aria-hidden="true">{{step.number}}</span>
            </div>
        </li>
    </ol>
</div>
